// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { ExecutedCollateralTransfer } from '@daml.js/utility-collateral-app-v1/lib/Utility/Collateral/App/Model/Collateral';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';
import { useOperatorParty } from '../../utility-operator/useOperatorParty';

export const useExecutedCollateralTransfer: () => UseQueryResult<
  TemplateContract<ExecutedCollateralTransfer>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const operator = useOperatorParty()?.data || '';
  const offset = useLedgerEnd();
  return useQuery({
    queryKey: ['ExecutedCollateralTransfer', ledgerApi, operator, offset],
    queryFn: async () => {
      return ledgerApi.queryExecutedCollateralTransfer(offset!, operator);
    },
  });
};
